package com.mencanhealth.admin.ui.components

import androidx.compose.runtime.Composable
import com.mencanhealth.admin.model.SubscriptionTier
import org.jetbrains.compose.web.dom.*

@Composable
fun TierBadge(tier: SubscriptionTier) {
    Span({
        classes("tier-badge", "tier-${tier.name.lowercase()}")
    }) {
        Text(tier.name)
    }
}
